export default __webpack_public_path__ + "static/media/Upskill.f39ec6ea.svg";